// Copyright (C) 2021 TANNER AG

import React from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { Heading2, Heading3 } from "../styleguide";
import buildAssetUrl from "../utils/buildAssetUrl";

const styles = (theme) => ({
    root: {
        padding: 16,
        color: "#fff",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 230,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        textDecoration: "none",
        transition: "all 0.3s",
        boxShadow:
            "rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px",

        "&:hover": {
            boxShadow:
                "rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px",
        },
    },
    disabled: {
        opacity: 0.4,
        userSelect: "none",
        boxShadow: "none",
        pointerEvents: "none",
        touchAction: "none",

        "& $number, & $title": {
            color: "#fff",
        },
    },
    number: {
        textTransform: "uppercase",
        color: "#e40045",
        fontWeight: "bold",
        fontFamily: "MANEurope, Arial, sans-serif",
    },
    title: {
        textTransform: "uppercase",
        color: "#303a44",
        fontWeight: "bold",
        fontFamily: "MANEurope, Arial, sans-serif",
    },
    titleLight: {
        color: "#fff",
    },
    intro: {
        color: "#fff",
    },
    content: {},
});

const getBuildAssetUrl = (image) => {
    if (!image) {
        return "";
    }

    const { url } = buildAssetUrl(image, 600);
    return url;
};

const IntroCard = withStyles(styles)(({ number, baseRoute, slug, image, intro, title, disabled, light, classes }) => {
    const url = getBuildAssetUrl(image);
    return (
        <Grid item md={6}>
            <Link
                className={classnames(classes.root, { [classes.disabled]: disabled })}
                style={{ backgroundImage: `url(${url})` }}
                to={`${baseRoute}/${slug}`}
                title={intro}
            >
                <div className={classes.content}>
                    <Heading2 className={classes.number}>{number}</Heading2>
                    <Heading3 className={classnames(classes.title, { [classes.titleLight]: light })}>{title}</Heading3>
                </div>
            </Link>
        </Grid>
    );
});

export default IntroCard;



// WEBPACK FOOTER //
// ./src/emobility/IntroCard.js